import { Form, Input } from "antd";
import { Rule } from "antd/es/form";
import { useMemo } from "react";

export const NameFormItem = () => {
  const rules: Rule[] = useMemo(
    () => [
      {
        required: true,
        validateTrigger: "onSubmit",
      },
      {
        max: 20,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  return (
    <Form.Item className="w-100" label="Name" name="name" rules={rules}>
      <Input />
    </Form.Item>
  );
};
